import type { ReactNode } from "react";
import { createPortal } from "react-dom";
import { useTopbarSlot } from "@/components/shell/TopbarSlotContext";

/**
 * Renders its children into the shell's `#topbar-actions-slot` — the right side
 * of the page header row — so a page's primary actions live in the shared
 * header instead of somewhere inside the page body (GUIDELINES.md §3.4).
 *
 * Falls back to rendering inline when there is no slot (a shell-free route, or
 * a component test rendering the page on its own), so a page never loses its
 * Save button to the absence of a shell.
 */
export function TopbarActionsPortal({ children }: { children: ReactNode }) {
  const { slot } = useTopbarSlot();
  return slot ? createPortal(<>{children}</>, slot) : <>{children}</>;
}
